
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-5---error-handling"}}>{`Ex. 5 - Error Handling`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Actuellement notre application ne gère pas les cas d'erreur. Lorsque l'on utilise une API externe, on ne la maîtrise pas et il faut toujours s'attendre à avoir des erreurs.`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous allons utiliser les `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://reactjs.org/docs/error-boundaries.html"}}>{`Error Boundaries`}</MDXTag>{`, avec cette technique, nous serons à la fois tolérants aux erreurs issues de l'API mais aussi à celles issues de notre propre code.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Créer une `}<MDXTag name="inlineCode" components={components} parentName="li">{`ErrorBoundary`}</MDXTag>{` simple dans `}<MDXTag name="inlineCode" components={components} parentName="li">{`src/components/Catch.js`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Englober toute l'application avec le composant `}<MDXTag name="inlineCode" components={components} parentName="li">{`Catch`}</MDXTag>{` dans `}<MDXTag name="inlineCode" components={components} parentName="li">{`index.js`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Modifier le Hook custom `}<MDXTag name="inlineCode" components={components} parentName="li">{`useMovieSearch`}</MDXTag>{` pour emettre une erreur lorsque la requête échoue`}</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`Lorsque le champs de recherche est vide, j'ai un message d'erreur.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-5/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"error-boundary--implémentation"}}>{`Error Boundary : implémentation`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`import React, { Component } from 'react'

export default class Catch extends Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    // Mise à jour du state, au prochain rendu, nous saurons qu'une erreur a été catchée
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      // Affichage du fallback de notre choix
      return <h1>Something went wrong.</h1>
    }

    return this.props.children
  }
}
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"error-boundary--utilisation"}}>{`Error Boundary : utilisation`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`ReactDOM.render(
  <Catch>
    <App />
  </Catch>,
  document.getElementById('root'),
)
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"stratégie-pour-throw"}}>{`Stratégie pour `}<MDXTag name="inlineCode" components={components} parentName="h3">{`throw`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`import { useState, useEffect } from 'react'

function useApi() {
  // State contenant le résultat
  const [state, setState] = useState({ result: null, error: null })

  useEffect(() => {
    request()
      // Lorsque tout se passe bien, j'obtiens un résultat
      .then(result => setState({ result, error: null }))
      // En cas d'erreur, le catch est appelé
      .catch(error => setState({ error, result: null }))
  })

  // Si une erreur a été retournée par la requête, alors je throw
  if (state.error) {
    throw state.error
  }

  return state.result
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  